// Where a user lands after signing in (when there is no saved deep link to return to).
// Customers (client role) land on their Customer Workspace; everyone else on Jobs.
export const CLIENT_HOME_ROUTE = '/home';
export const DEFAULT_LANDING_ROUTE = '/jobs';

export const getLandingRoute = (role) =>
  role === 'client' ? CLIENT_HOME_ROUTE : DEFAULT_LANDING_ROUTE;
